import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Select from 'react-select';

// API
import { updateUnityAppVerbosityApi } from '../apis/app.api';
import { deleteSession } from '../apis/user.api';
import {
  verifyUser,
  addOrganizationToDB,
  fetchOrganizationsApi,
  fetchUserCacheApi,
  addUserToCache,
  processBatchUpload,
  updateOrganizationLearningPathEnabledApi
} from '../apis/admin.api';
import { deleteUserSessions, createBackupOfDB, createCustomChapterGroupApi } from '../apis/data.api';
import { subscriptionApi } from '../apis/subscription.api';
import { registryApi } from '../apis/registry.api';
import { fetchLoginNotificationApi, updateLoginNotificationApi } from '../apis/notification.api';
// PROC
// REDUX
import { setAppVerbosity, setCurrentPage } from '../redux/app.slice';
import { setNotification } from '../redux/notification.slice';
// COMPONENTS
import BatchUpload from '../components/BatchUpload';

const Administrator = () => {
  const regions = process.env.REACT_APP_REGIONS && process.env.REACT_APP_REGIONS.split(',') || [];
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { app, user } = useSelector((state) => ({ ...state }));

  const [verbosity, setVerbosity] = useState(app.verbosity);
  const [queuedUserArray, setQueuedUserArray] = useState([]);
  const [organizationArray, setOrganizationArray] = useState([]);
  const [organizationOptions, setOrganizationOptions] = useState([]);
  const [selectedOrg, setSelectedOrg] = useState('');
  const [orgName, setOrgName] = useState('');
  const [orgAddress, setOrgAddress] = useState('');
  const [orgContact, setOrgContact] = useState('');
  const [orgEmail, setOrgEmail] = useState('');
  const [orgPhone, setOrgPhone] = useState(""); // eslint-disable-line
  const [orgCredits, setOrgCredits] = useState(0);
  const [delEmail, setDelEmail] = useState('');

  const [userName, setUserName] = useState('');
  const [userOrg, setUserOrg] = useState('');
  const [userEmail, setUserEmail] = useState('');
  const [userRole, setUserRole] = useState('trainee');
  const [addUserToCacheResponse, setAddUserToCacheResponse] = useState({ data: '' })
  const [addOrganizationToDBResponse, setAddOrganizationToDBResponse] = useState({ data: '' })

  const [userLoggedIn, setUserLoggedIn] = useState(false); // eslint-disable-line

  const [pdfUrl, setPdfUrl] = useState('');
  const [regionOptions, setRegionOptions] = useState([]);

  const [selectedOrgRegions, setSelectedOrgRegions] = useState([]);
  const [isBatchProcessing, setIsBatchProcessing] = useState(false);

  const [selectedOrgForLearningPath, setSelectedOrgForLearningPath] = useState(null);
  const [learningPathEnabled, setLearningPathEnabled] = useState(false);

  const [notificationMessage, setNotificationMessage] = useState('');


  useEffect(() => {
    dispatch(setCurrentPage('administrator'));
    setVerbosity(app.verbosity);
  }, []);

  useEffect(() => {
    // console.log(
    //   'Administrator ===============> user:',
    //   user,
    //   user.user.idToken
    // );
    const orgRes = fetchOrganizationsApi(user.user.idToken);  // eslint-disable-line
    // console.log('===============> orgArr:', orgRes.data);
  }, []);

  useEffect(() => {
    if (user.user.idToken !== null) {
      fetchUserQueue();
      fetchOrganizations();
      buildRegionOptions();
      fetchNotification();
    }
  }, [user.user.role]); // eslint-disable-line

  const fetchNotification = async () => {
    try {
      const res = await fetchLoginNotificationApi(user.user.idToken);
      setNotificationMessage(res.data.message || '');
    } catch (err) {
      console.log('Fetch notification error:', err);
    }
  };

  const updateNotification = async () => {
    try {
      const response = await updateLoginNotificationApi(user.user.idToken, notificationMessage);
      const { flag, message } = response.data;
      setNotificationMessage(message || '');
      dispatch(setNotification({ flag: !!flag, message: message || '' }));
      toast.success(flag ? 'Notification message updated' : 'Notification cleared');
    } catch (error) {
      console.error('Update notification error:', error);
      toast.error('Failed to update notification. Please try again.');
    }
  };

  const buildRegionOptions = () => {
    const regionOptions = regions.map((r) => ({
      key: r, value: r, label: r
    }))
    setRegionOptions(regionOptions);
  }

  const fetchOrganizations = async () => {
    try {
      const orgRes = await fetchOrganizationsApi(user.user.idToken);
      let orgResOptions = [];
      orgRes.data.forEach((o, i) => {
        orgResOptions.push({
          key: i, value: o._id, label: o.name
        })
      })
      // console.log('========> orgArr:', orgResOptions);
      setOrganizationArray(orgRes.data);
      setOrganizationOptions(orgResOptions);
    } catch (err) {
      console.log(err);
    }
  };
  const fetchUserQueue = async () => {
    const cacheRes = await fetchUserCacheApi(user.user.idToken);
    // console.log('========> orgcacheResArr:', cacheRes.data);
    setQueuedUserArray(cacheRes.data);
  };

  // TODO: Migrate user(s) to Registry from Register page
  const addUser = async () => {
    try {
      const newUser = {
        name: userName,
        organization: userOrg,
        email: userEmail.toLowerCase(),
        region: selectedOrgRegions[0]?.value || process.env.REACT_APP_REGION_CODE,
        role: userRole
      };
      const response = await addUserToCache(user.user.idToken, newUser);
      console.log('--> addUserToCacheResponse:', response);
      await setAddUserToCacheResponse(response);

      if (response.data.error) {
        toast.error(`Failed to add user: ${response.data.error}`);
      } else {
        toast.success(`Successfully added user ${userName} to cache`);
        // Clear form fields
        setUserName('');
        setUserEmail('');
        setSelectedOrg('');
        setUserOrg('');
      }

      await fetchUserQueue();
    } catch (error) {
      console.error('Add user error:', error);
      toast.error('Failed to add user. Please try again.');
    }
  };
  let customGroupName = `custom-${orgName.toLowerCase()}`;
  customGroupName = customGroupName.split(" ").join("-");

  const addOrg = async () => {
    console.log('----->> addOrg (Administrator 144): ', orgName, orgContact, orgEmail, orgPhone, orgAddress, orgCredits, selectedOrgRegions);
    try {
      const newOrg = {
        name: orgName,
        contact: orgContact,
        email: orgEmail,
        phone: orgPhone,
        address: orgAddress,
        customChapterGroup: customGroupName,
        regions: selectedOrgRegions.map(r => r.value)
      };
      const cg = {
        name: customGroupName,
        description: null,
        chapters: [],
        restrictedTo: null,
        lastUpdated: new Date(),
        maintainer: null
      }

      let response = await addOrganizationToDB(user.user.idToken, newOrg);
      console.log('--> addOrganizationToDB response (Administrator 166):', response);
      await setAddOrganizationToDBResponse(response);

      if (response.data.error) {
        toast.error(`Failed to add organization: ${response.data.error}`);
      } else {
        response = await createCustomChapterGroupApi(user.user.idToken, cg);
        console.log('--> createCustomChapterGroupApi response (Administrator 173):', response);

        // Migrate to Registry
        const migrationData = {
          region: selectedOrgRegions[0]?.value || process.env.REACT_APP_REGION_CODE,
          db: process.env.REACT_APP_DEPLOY_SERVER || 'dev',
          filterKey: 'name',
          filterValue: orgName,
          updateIfExists: true
        };

        try {
          const migrationResponse = await registryApi.migrateOrganizations(user.user.idToken, migrationData);
          console.log('----->>> Migration response (Administrator 186):', migrationResponse);
          if (migrationResponse.success) {
            toast.success(`Organization ${orgName} migrated successfully`);

            // Create subscription with maxUsers from orgCredits
            const subscriptionData = {
              type: "enterprise",
              status: "active",
              maxUsers: Math.min(parseInt(orgCredits), 100000),
              allowedFeatures: ["feature1", "feature2", "feature3"],
              payment: {
                method: "credit_card",
                interval: "annual",
                amount: 200.00,
                currency: "USD",
                lastFour: "4242",
                nextBillingDate: new Date(
                  Date.now() + (
                    "annual" === "annual"
                      ? 365 * 24 * 60 * 60 * 1000  // 1 year in milliseconds
                      : 30 * 24 * 60 * 60 * 1000   // 30 days in milliseconds
                  )
                ).toISOString(),
              },
              startDate: new Date().toISOString(),
              endDate: new Date(Date.now() + 365 * 24 * 60 * 60 * 1000).toISOString(),
              autoRenew: true
            };

            try {
              const subscriptionResponse = await subscriptionApi.createSubscription(
                user.user.idToken,
                orgName,
                subscriptionData
              );
              console.log('--> CREATE Subscription response:', subscriptionResponse);
              if (subscriptionResponse.success) {
                toast.success('Subscription CREATED successfully');
              } else {
                console.log('----->>> CREATE Subscription WARNING (Administrator 219):', subscriptionResponse);
                toast.warning('Organization created but subscription setup had issues');
              }
            } catch (subscriptionError) {
              console.error('Subscription creation error:', subscriptionError);
              toast.error('Organization created but subscription setup failed');
            }
          } else {
            console.log('----->>> Migration WARNING (Administrator 226):', migrationResponse);
            toast.warning('Organization added but migration had warnings');
          }
        } catch (migrationError) {
          console.error('!!! ---> Migration error (Administrator 230):', migrationError);
          toast.error('Organization added but migration failed');
        }

        toast.success(`Successfully added organization ${orgName}`);
        // Clear form fields
        setOrgName('');
        setOrgContact('');
        setOrgEmail('');
        setOrgPhone('');
        setOrgAddress('');
        setOrgCredits(0);
        setSelectedOrgRegions([]);
      }

      await fetchOrganizations();
    } catch (error) {
      console.error('Add organization error:', error);
      toast.error('Failed to add organization. Please try again.');
    }
  };

  const handleSelectOrgForLearningPath = (selection) => {
    setSelectedOrgForLearningPath(selection);
    const selectedOrgObj = organizationArray.find((o) => o._id === selection.value);
    setLearningPathEnabled(selectedOrgObj?.learningPathEnabled || false);
  };

  const updateOrgLearningPath = async () => {
    if (!selectedOrgForLearningPath) {
      toast.warning('Please select an organization first');
      return;
    }

    try {
      const response = await updateOrganizationLearningPathEnabledApi(
        user.user.idToken,
        selectedOrgForLearningPath.value,
        learningPathEnabled
      );

      console.log('--> updateOrgLearningPath response:', response);

      if (response.data.error.isError === "0") {
        toast.success(`Successfully updated learning path status for ${selectedOrgForLearningPath.label}`);
        await fetchOrganizations(); // Refresh organization list
      } else {
        toast.error(`Failed to update: ${response.data.error.message}`);
      }
    } catch (error) {
      console.error('Update organization learning path error:', error);
      toast.error('Failed to update organization. Please try again.');
    }
  };

  const backupDatabase = async () => {
    const response = await createBackupOfDB(user.user.idToken);
    console.log('backupDatabase:', response);
    // TBD check response and modify toast
    toast('DB successfully backed up to S3');
  };
  const deleteUserSessionData = async () => {
    const response = await deleteUserSessions(user.user.idToken, delEmail);
    console.log('deleteUserSessions:', response);
    // TBD check response and modify toast
    toast('Successfully deleted user session data.');
  };

  const updateVerbosity = async () => {
    dispatch(setAppVerbosity(verbosity));
    await updateUnityAppVerbosityApi(user.user.idToken, verbosity);
    toast(`UnityApp verbosity for ${user.user.email} is now set to ${verbosity}`);
  };

  const openNewPage = (newPageUrl) => {
    console.log('openNewPage: ', newPageUrl);
    window.open(newPageUrl, '_blank');
  };

  const updateUserRole = async (value) => {
    await setUserRole(value);
  };

  const handleSelectUserOrg = (selection) => {
    console.log("handleSelectUserOrg:", selection)
    console.log("organizationArray:", organizationArray)
    setSelectedOrg(selection);
    const selectedOrgObj = organizationArray.find((o) => o.name === selection.label);
    setUserOrg(selectedOrgObj.name);
  }

  const handleBatchProcess = async (batchData, setStatusCallback) => {
    setIsBatchProcessing(true);

    try {
      setStatusCallback('Processing batch upload...');

      const response = await processBatchUpload(user.user.idToken, batchData);
      console.log('Batch processing response:', response.data);

      if (response.data.success) {
        const summary = response.data.summary;
        const hasWarnings = response.data.errors.some(error => error.startsWith('WARNING'));
        const hasFailures = response.data.errors.some(error => error.startsWith('FAILED'));

        // Update status with organization info
        if (response.data.organization) {
          if (response.data.organization.isNew) {
            setStatusCallback(`Organization "${batchData.organization.name}" created successfully!`);
          } else if (response.data.organization.warning) {
            setStatusCallback(`WARNING: ${response.data.organization.warning} - proceeding with users`);
          }
        }

        // Final status update
        const statusMessage = `Batch processing completed: ${summary.successfulUsers}/${summary.totalUsers} users processed`;
        const detailMessage = summary.newUsers > 0 || summary.existingUsers > 0 || summary.skippedUsers > 0
          ? ` (${summary.newUsers} new, ${summary.existingUsers} existing${summary.skippedUsers > 0 ? `, ${summary.skippedUsers} skipped for region` : ''}${summary.failedUsers > 0 ? `, ${summary.failedUsers} failed` : ''})`
          : '';

        setStatusCallback(statusMessage + detailMessage + (summary.currentRegion ? ` | Region: ${summary.currentRegion}` : ''), response.data);

        // Show appropriate toast message
        if (hasFailures && hasWarnings) {
          console.warn('Batch processing warnings and errors:', response.data.errors);
          toast.warning(`Completed with warnings and some failures. ${summary.successfulUsers}/${summary.totalUsers} users processed successfully${summary.skippedUsers > 0 ? ` (${summary.skippedUsers} skipped for region)` : ''}.`);
        } else if (hasWarnings) {
          console.warn('Batch processing warnings:', response.data.errors);
          toast.warning(`Completed with warnings. ${summary.successfulUsers}/${summary.totalUsers} users processed${summary.skippedUsers > 0 ? ` (${summary.skippedUsers} skipped for region)` : ''}.`);
        } else if (hasFailures) {
          console.error('Batch processing errors:', response.data.errors);
          toast.error(`Partially completed. ${summary.successfulUsers}/${summary.totalUsers} users processed successfully${summary.skippedUsers > 0 ? ` (${summary.skippedUsers} skipped for region)` : ''}.`);
        } else {
          const regionInfo = summary.skippedUsers > 0 ? ` (${summary.skippedUsers} users skipped for region)` : '';
          toast.success(`Successfully processed ${summary.organizationStatus.toLowerCase()} and ${summary.successfulUsers} users${regionInfo} for region ${summary.currentRegion}`);
        }

        // Log detailed results for debugging
        console.log('Detailed batch results:', {
          organization: response.data.organization,
          userSummary: summary,
          errors: response.data.errors,
          users: response.data.users
        });

        // Refresh the organization and user cache lists
        await fetchOrganizations();
        await fetchUserQueue();

      } else {
        setStatusCallback('ERROR: Batch processing failed', response.data);
        toast.error(`Batch processing failed: ${response.data.errors.join(', ')}`);
      }

    } catch (error) {
      console.error('Batch processing error:', error);
      setStatusCallback(`Error: ${error.message}`);
      toast.error(`Batch processing failed: ${error.message}`);
    } finally {
      setIsBatchProcessing(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-100 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <h1 className="text-3xl font-bold text-gray-900 mb-8">Administrator Dashboard</h1>

        {/* Batch Upload Section */}
        <div className="mb-8">
          <BatchUpload
            onBatchProcess={handleBatchProcess}
            isProcessing={isBatchProcessing}
          />
        </div>

        <div className="bg-white shadow overflow-hidden sm:rounded-lg">
          <div className="px-4 py-5 sm:p-6">
            <h2 className="text-lg leading-6 font-medium text-gray-900 mb-4">Organizations & User Queue</h2>

            <div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-4">
              {/* Organization Form */}
              <div>
                <h3 className="text-md font-medium text-gray-700 mb-2">Add Organization</h3>
                <input
                  type="text"
                  value={orgName || ''}
                  placeholder="Name"
                  onChange={(e) => setOrgName(e.target.value)}
                  className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                />
                <Select
                  isMulti
                  options={regionOptions}
                  value={selectedOrgRegions}
                  onChange={setSelectedOrgRegions}
                  placeholder="Select Regions"
                  className="mt-1"
                  styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                />
                <input
                  type="text"
                  value={orgContact || ''}
                  placeholder="Contact Name"
                  onChange={(e) => setOrgContact(e.target.value)}
                  className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                />
                <input
                  type="text"
                  value={orgEmail || ''}
                  placeholder="Email"
                  onChange={(e) => setOrgEmail(e.target.value)}
                  className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                />
                <input
                  type="text"
                  value={orgAddress || ''}
                  placeholder="Address"
                  onChange={(e) => setOrgAddress(e.target.value)}
                  className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                />
                <input
                  type="number"
                  value={orgCredits || ''}
                  placeholder="Max Users"
                  onChange={(e) => setOrgCredits(Math.min(parseInt(e.target.value), 100000))}
                  className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                />
                <button
                  onClick={addOrg}
                  className="mt-3 w-full inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                >
                  Add Org
                </button>
              </div>

              {/* User Register Cache Form */}
              <div>
                <h3 className="text-md font-medium text-gray-700 mb-2">Add User to Cache</h3>
                <input
                  type="text"
                  value={userName || ''}
                  placeholder="Name"
                  onChange={(e) => setUserName(e.target.value)}
                  className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                />
                <Select maxMenuHeight={200} value={selectedOrg} options={organizationOptions} onChange={(option) => handleSelectUserOrg(option)} styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }} />
                <input
                  type="text"
                  value={userEmail || ''}
                  placeholder="Email"
                  onChange={(e) => setUserEmail(e.target.value)}
                  className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                />
                <select
                  defaultValue="trainee"
                  className="mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md"
                  onChange={(e) => updateUserRole(e.target.value)}
                >
                  <option value="trainee">trainee</option>
                  <option value="leader">leader</option>
                  <option value="admin">admin</option>
                </select>
                <button
                  onClick={addUser}
                  className="mt-3 w-full inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                >
                  Add User
                </button>
              </div>
              {/* Learning Path Section */}
              <div>
                <h3 className="text-md font-medium text-gray-700 mb-2">Learning Path Settings</h3>
                <Select
                  maxMenuHeight={200}
                  value={selectedOrgForLearningPath}
                  options={organizationOptions}
                  onChange={handleSelectOrgForLearningPath}
                  placeholder="Select Organization"
                  className="mt-1"
                  styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                />

                <div className="mt-3">
                  <label className="flex items-center space-x-2">
                    <input
                      type="checkbox"
                      checked={learningPathEnabled}
                      onChange={(e) => setLearningPathEnabled(e.target.checked)}
                      className="h-4 w-4 text-indigo-600 focus:ring-indigo-500 border-gray-300 rounded"
                    />
                    <span className="text-sm text-gray-700">Enable Learning Path</span>
                  </label>
                </div>

                <button
                  onClick={updateOrgLearningPath}
                  disabled={!selectedOrgForLearningPath}
                  className={`mt-3 w-full inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white ${selectedOrgForLearningPath
                      ? 'bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500'
                      : 'bg-gray-400 cursor-not-allowed'
                    }`}
                >
                  Update Learning Path
                </button>

                {selectedOrgForLearningPath && (
                  <div className="mt-3 text-xs text-gray-500">
                    Selected: {selectedOrgForLearningPath.label}
                    <br />
                    Status: {learningPathEnabled ? 'Enabled' : 'Disabled'}
                  </div>
                )}
              </div>

              {/* Existing Organizations and User Cache */}
              <div>
                <h3 className="text-md font-medium text-gray-700 mb-2">Existing Organizations</h3>
                <ul className="mt-1 max-h-40 overflow-auto bg-gray-50 rounded-md py-2 px-3">
                  {organizationArray.map((o) => (
                    <li key={o.name} className="text-sm text-gray-600">{o.name}</li>
                  ))}
                </ul>

                <h3 className="text-md font-medium text-gray-700 mt-4 mb-2">User Cache</h3>
                <ul className="mt-1 max-h-40 overflow-auto bg-gray-50 rounded-md py-2 px-3">
                  {queuedUserArray.map((u) => (
                    <li key={u.email} className="text-sm text-gray-600">
                      {u.name}, {u.email}, {u.organization}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>

        {/* Database Management Section */}
        <div className="mt-8 bg-white shadow overflow-hidden sm:rounded-lg">
          <div className="px-4 py-5 sm:p-6">
            <h2 className="text-lg leading-6 font-medium text-gray-900 mb-4">Database Management</h2>
            <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
              <div>
                <h3 className="text-md font-medium text-gray-700 mb-2">Backup Database to S3</h3>
                <button
                  onClick={backupDatabase}
                  className="w-full inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                >
                  Create Backup
                </button>
              </div>

              {(user.user.email === 'jcrist50@gmail.com' || user.user.email === 'skygnite@gmail.com') && (
                <div>
                  <h3 className="text-md font-medium text-gray-700 mb-2">Delete User Session Data</h3>
                  <input
                    type="text"
                    placeholder="Email"
                    onChange={(e) => setDelEmail(e.target.value)}
                    className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                  />
                  <button
                    onClick={deleteUserSessionData}
                    className="mt-3 w-full inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                  >
                    Delete Data
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>

        {/* App Settings Section */}
        <div className="mt-8 bg-white shadow overflow-hidden sm:rounded-lg">
          <div className="px-4 py-5 sm:p-6">
            <h2 className="text-lg leading-6 font-medium text-gray-900 mb-4">App Settings</h2>
            <div>
              <h3 className="text-md font-medium text-gray-700 mb-2">Set Unity App Verbosity</h3>
              <select
                defaultValue={verbosity}
                onChange={(e) => setVerbosity(e.target.value)}
                className="mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md"
              >
                <option value={0}>0</option>
                <option value={1}>1</option>
                <option value={2}>2</option>
              </select>
              <button
                onClick={updateVerbosity}
                className="mt-3 w-full inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
              >
                Update Verbosity
              </button>
            </div>

            <div className="mt-6">
              <h3 className="text-md font-medium text-gray-700 mb-2">Login Notification Message</h3>
              <input
                type="text"
                value={notificationMessage}
                placeholder="Leave empty to disable the notification"
                onChange={(e) => setNotificationMessage(e.target.value)}
                className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
              />
              <button
                onClick={updateNotification}
                className="mt-3 w-full inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
              >
                Update Notification
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Administrator;